<div [class]="containerClass()" aria-hidden="true">
  <svg
    [style]="iconStyle()"
    [class]="svgClass()"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 -960 960 960"
    fill="none"
  >
    <path
      d="M80-160v-640h640v260l160-160v440L720-420v260H80Zm80-80h480v-480H160v480Zm0 0v-480 480Z"
    />
  </svg>
</div>
